<template>
    <modal size="lg" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Time Off History: {{ enrollment.plan_name }}</h3>
        </template>

        <slot>
            <p v-if="entries && !entries.length" class="text-muted">Nothing has been posted yet.</p>
            <table class="table css-table widget-table" v-if="entries && entries.length">
                <thead>
                    <tr>
                        <th class="pl-0">Date</th>
                        <th>Type</th>
                        <th class="text-right">Hours</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="entry in entries" :key="entry.id">
                        <td class="pl-0 text-nowrap">{{ $filters.date(entry.effective_date) }}</td>
                        <td>
                            {{ entry.entry_type_pretty }}
                            <span v-if="entry.reverses_id" class="text-muted">(reversal)</span>
                        </td>
                        <td class="text-right">{{ Number(entry.hours).toFixed(2) }}</td>
                        <td>
                            <div v-if="entry.earning_statement_number">Statement #{{ entry.earning_statement_number }}</div>
                            <div v-if="entry.basis_hours !== null">{{ Number(entry.basis_hours).toFixed(2) }} hours worked</div>
                            <div v-if="entry.reason">{{ entry.reason }}</div>
                            <div v-if="entry.created_by" class="text-muted">By {{ entry.created_by }} on {{ $filters.date(entry.created_on) }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Done</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'employee', 'enrollment', ],
    mixins: [ModalMixin],
    emits: ['close', ],
    data() {
        return {
            entries: null,
        }
    },
    mounted() {
        this.$store.dispatch('START_LOADING')
        this.$api.get(`/clients/${this.client.id}/employees/${this.employee.id}/accrual-plans/${this.enrollment.id}/ledger`).then(resp => {
            this.$store.dispatch('STOP_LOADING')
            this.entries = resp
        }).catch(errors => {
            this.$store.dispatch('STOP_LOADING')
            this.$bus.showError(errors.__all__)
        })
    },
}
</script>
